import { render } from "./Center_Preview.vue?vue&type=template&id=04846d65"
import script from "./Center_Preview.vue?vue&type=script&lang=js"
export * from "./Center_Preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__